import { useTheme } from '@emotion/react'

import type { IconComponent } from '@twistopayments/design-system/icons/constants'

import { getIconVariantColor } from '../../utils/get-icon-variant-color'
import { useTagContext } from '../../utils/tag.context'

import * as styles from './tag-icon.styles'

type Props = {
  icon: IconComponent
  className?: string
}

export const TagIcon = ({ icon, className }: Props) => {
  const theme = useTheme()
  const { size, variant } = useTagContext()

  const Icon = icon
  const iconColor = getIconVariantColor(variant)

  return (
    <div
      className={className}
      css={[styles.container, styles.containerSize(theme)[size]]}
    >
      <Icon color={iconColor} height="100%" width="100%" />
    </div>
  )
}
